'use strict';
var parent = require('../../es/object/get-own-property-names');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/get-own-property-names.js
// module id = 777
// module chunks = 13